<template>

    <v-page>

        <v-page-header icon="fas fa-user-circle">
            <v-breadcrumb>
                <v-breadcrumb-item>Campaign Member</v-breadcrumb-item>
            </v-breadcrumb>
        </v-page-header>

        <v-page-body>

            <v-page-section padded>
                <template #header>
                    <span>Member</span>
                    <v-identifier :uuid="member.id" />
                </template>
                <template #body>
                    <v-prop-list
                        class="w-50p"
                        :properties="{
                            'Name': member.customer.name,
                            'Email': member.customer.email,
                        }">
                    </v-prop-list>
                </template>
                <template #footer>
                    <v-button size="xs" btn-style="white" @click.native="viewCustomer">View Customer</v-button>
                </template>
            </v-page-section>

            <v-page-section padded>
                <template #title>Journeys</template>
                <template #body>
                    <v-table bordered>
                        <thead>
                            <th>Entered</th>
                            <th>Exited</th>
                            <th>In Progress</th>
                        </thead>
                        <tbody>
                            <tr v-for="j in member.recent_journeys" :key="j.id" @click="viewJourney(j.id)">
                                <td v-if="j.entered_at">{{ j.entered_at | dateTime }}</td><td v-else>&mdash;</td>
                                <td v-if="j.exited_at">{{ j.exited_at | dateTime }}</td><td v-else>&mdash;</td>
                                <td :class="{ 'text-success': j.in_progress }">{{ j.in_progress ? 'Yes' : 'No' }}</td>
                            </tr>
                        </tbody>
                    </v-table>
                </template>
                <template #footer>
                    <v-button size="xs" btn-style="white" @click.native="viewJourneys">View All Journeys</v-button>
                </template>
            </v-page-section>

            <v-page-section padded>
                <template #title><span>Timeline</span>
                </template>
                <template #body>
                    <v-table :selectable="false" bordered>
                        <thead>
                            <th>Date</th>
                            <th>Event</th>
                        </thead>
                        <tbody>
                            <tr v-for="e in member.recent_events" :key="e.id">
                                <td>{{ e.created_at | dateTime }}</td>
                                <td>{{ e.title }}</td>
                            </tr>
                        </tbody>
                    </v-table>
                </template>
                <template #footer>
                    <v-button size="xs" btn-style="white" @click.native="viewEvents">View All Events</v-button>
                </template>
            </v-page-section>

        </v-page-body>

    </v-page>

</template>

<script>

import CampaignMemberApi from '@api/CampaignMemberApi';

export default {

    data() {
        return {
            member: null,
        }
    },

    mounted() {
        this.getMember();
    },

    methods: {

        getMember() {
            this.$store.commit('loading', true);
            CampaignMemberApi.getMember(this.$route.params.id)
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.member = response.data.data;
                    this.$events.$emit('pageLoaded');
                }, () => {
                    this.$store.commit('loading', false);
                    this.$events.$emit('pageError');
                });
        },

        viewCustomer() {
            this.$router.push({
                name: 'customer',
                params: { id: this.member.customer_id },
            });
        },

        viewJourney(journeyId) {
            this.$router.push({
                name: 'campaigns-member-journey',
                params: { id: this.member.id, journey_id: journeyId },
            });
        },

        viewJourneys() {
            this.$router.push({
                name: 'campaigns-member-journeys',
                params: { id: this.member.id },
            });
        },

        viewEvents() {
            this.$router.push({
                name: 'campaigns-member-events',
                params: { id: this.member.id },
            });
        },

    },

}

</script>
